import { render, staticRenderFns } from "./course-plan.vue?vue&type=template&id=2e0b1ad1&scoped=true&"
import script from "./course-plan.vue?vue&type=script&lang=js&"
export * from "./course-plan.vue?vue&type=script&lang=js&"
import style0 from "./course-plan.vue?vue&type=style&index=0&id=2e0b1ad1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b1ad1",
  null
  
)

export default component.exports